<template>
  <div class="container">
    <div class="shopDetail">
      <div class="shop-title">任务详情</div>
      <div class="hrr"></div>
      <div class="hrs"></div>
      <div class="shop-img">
        <img  class="shopImg" src="../../../static/image/remenLong.png" alt="" v-if="!missionInfo.longPicture">
        <img class="shopImg" :src="missionInfo.longPicture" alt v-else/>
      </div>
      <!--      =======================已领取任务不显示该部分=============================start-->
      <div class="title" v-if="region=='taskDetail'">任务介绍</div>

      <div class="task-list" v-if="region=='taskDetail'">
        <div class="task-tr">
          <div class="task-name">项目级别</div>
          <div class="task-value" v-if="missionInfo.level == 0">不限</div>
          <div class="task-value" v-if="missionInfo.level == 1">A级设计</div>
          <div class="task-value" v-if="missionInfo.level == 2">B级设计</div>
          <div class="task-value" v-if="missionInfo.level == 3">C级设计</div>
          <div class="task-value" v-if="missionInfo.level == 4">D级设计</div>
        </div>
        <div class="task-tr">
          <div class="task-name">材质</div>
          <div class="task-value">{{missionInfo.material}}</div>
        </div>
        <div class="hr"></div>
        <div class="task-tr">
          <div class="task-name">工艺</div>
          <div class="task-value">{{missionInfo.technique}}</div>
        </div>
        <div class="task-tr">
          <div class="task-name">镶嵌</div>
          <div class="task-value">{{missionInfo.inset}}</div>
        </div>
        <div class="hr"></div>
        <div class="task-tr">
          <div class="task-name">风格</div>
          <div class="task-value">{{missionInfo.style}}</div>
        </div>
        <div class="task-tr">
          <div class="task-name">首饰类型</div>
          <div class="task-value">{{missionInfo.jewelryType}}</div>
        </div>
        <div class="hr"></div>
        <div class="task-tr">
          <div class="task-name">设计要求</div>
          <div class="task-value">{{missionInfo.designRequirement}}</div>
        </div>
       <!-- <div class="task-tr">
          <div class="task-name">价格上限</div>
          <div class="task-value">￥{{missionInfo.maxPay}}</div>
        </div>
        <div class="hr"></div>
        <div class="task-tr">
          <div class="task-name">价格下限</div>
          <div class="task-value">￥{{missionInfo.minPay}}</div>
        </div> -->
        <div class="hr"></div>
      </div>
      <!--      =======================已领取任务不显示该部分=============================end-->
      <!-- 引入表格组件 -->
      <div class="table-Region">
        <TableRegion ref="tableFrom" :missionInfo="missionInfo" :region="region"></TableRegion>
      </div>
      <!--      =======================已领取任务不显示该部分=============================start-->
      <div class="title" v-if="region=='taskDetail'">领取事项</div>
      <div class="receive" v-if="region=='taskDetail'">
        <div class="receive-name">平台等级要求</div>
        <div class="receive-val" v-if="missionInfo.requireDesignerLevel == 0">不限</div>
        <div class="receive-val" v-if="missionInfo.requireDesignerLevel == 1">LV1及以上</div>
        <div class="receive-val" v-if="missionInfo.requireDesignerLevel == 2">LV2及以上</div>
        <div class="receive-val" v-if="missionInfo.requireDesignerLevel == 3">LV3及以上</div>
        <div class="receive-val" v-if="missionInfo.requireDesignerLevel == 4">LV4</div>
      </div>

      <div class="receive receives" v-if="region=='taskDetail'">
        <div class="receive-name">投稿截止日期</div>
        <div class="receive-val">{{missionInfo.contributionEndTime}}</div>
      </div>
		<div class="receive receives" v-if="missionInfo.needNumber>0">
		  <div class="receive-name">需求款数</div>
		  <div class="receive-val">{{missionInfo.needNumber}}</div>
		</div>
		<div class="receive receives" v-if="missionInfo.receiveCount>0">
		  <div class="receive-name">领取人数</div>
		  <div class="receive-val">{{missionInfo.receiveCount}}</div>
		</div>
    
      <div class="title" v-if="region=='taskDetail'" style="padding-bottom: 0">任务描述</div>

      <div v-html="missionInfo.detail" v-if="region=='taskDetail'" style="padding: 0 30px;width: 95%;overflow: hidden;word-break:break-all;word-wrap:break-word" id="taskDetailInfo"></div>
      <!--      =======================已领取任务不显示该部分=============================end-->
    </div>
  </div>
</template>

<script>
  import TableRegion from "../tableRegion/tableRegion"; //引入表格组件
  import config from "../../api/config";

  export default {
    name: "shopDetail",
    props: ["region", "missionInfo"],
    components: {
      TableRegion,
    },
    data() {
      return {};
    },
    watch: {
      missionInfo(n, o) { //n为新值,o为旧值;
        this.missionInfo = n;
        let longPicture = this.missionInfo.longPicture;
        if(longPicture){
           this.missionInfo.longPicture = longPicture.indexOf("http") > -1 || longPicture.indexOf("https") > -1 ? longPicture : config.baseImgUrl + longPicture;
        }

      }
    },
    mounted() {
    },
    methods: {
      changeMissionInfo(missionInfo){
        this.$parent.changeMissionInfo(missionInfo);
      }
    },
  };
</script>


<style scoped>
  .container {
    width: 100%;
    background: #ffffff;
  }

  .task-list {
    padding: 0 30px;
  }

  .table-Region {
    margin: 18px 0 0 0;
  }

  .task-tr {
    width: 49%;
    display: inline-block;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    opacity: 1;
    color: #9e9e9e;
    padding: 15px 0;
  }

  .shop-img {
    padding: 0 30px;
  }

  .shopImg {
    width: 100%;
    height: 409px;
    margin: 24px 0 0 0;
  }

  .hrr {
    border: 1px solid #777777;
    width: 67px;
    margin: 0 0 0 30px;
  }

  .hrs {
    border-bottom: 1px solid #c7c7c7;
    width: 100%;
  }

  .hr {
    border-bottom: dashed 1px #c7c7c7;
  }

  .task-name {
    width: 30%;
    display: inline-block;
  }

  .task-value {
    width: 65%;
    display: inline-block;
  }

  .receive {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 21px;
    color: #9e9e9e;
    opacity: 1;
    margin: 0 0 0 30px;
  }

  .receives {
    margin: 12px 0 0 30px;
  }

  .receive-val {
    color: #3a3a3a;
    display: inline-block;
  }

  .receive-name {
    display: inline-block;
    width: 120px;
  }

  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 800;
    line-height: 28px;
    color: #222222;
    opacity: 1;
    padding: 18px 0 18px 30px;
  }

  .shop-title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 33px;
    color: #231815;
    opacity: 1;
    padding: 16px 0 16px 30px;
  }
  #taskDetailInfo >>> img{
    width: 100% !important;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shopDetail/shopDetail.vue